import styled, { css } from 'styled-components';

export const Header = styled.header`
  display: flex;
  height: 3rem;
  gap: 2rem;
  position: relative;

  .loading {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .flex-div {
    border: 0;
    background: transparent;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: .2rem .4rem;
    animation: fade 1s;
    color: var(--light-blue);
    h4 {
      font-size: 1rem;
    }
    img {
      height: 2.2rem;
      max-width: 2.2rem;
      margin-right: .4rem;
    }
    svg {
      margin-left: .3rem;
      transition: 0.5s;
    }
  } 

  .active {
    svg {
      transform: rotate(-180deg);
    }
  }
`;

export const Popover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 3rem;
  left: .4rem;
  padding: 0 .4rem .2rem;
  min-width: 170px;
  border-radius: 0.25rem; 
  transition:  0.4s;

  .scroll-children {
      padding: 0 0 .5rem;
      width: 100%;
      overflow: auto;
      margin-top: 10px;
      &::-webkit-scrollbar{
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px var(--light-blue);
        -webkit-box-shadow:  0 0 6px  transparent; 
        border-radius: 10px;
        max-height: 100px;
        height: 100%;

      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px var(--light-blue);
        border-radius: 20px;
        -webkit-box-shadow: inset 40px 0 6px var(--light-blue); 
        max-height: 50px;
        height: 100%;
      }
    }

  .flex-div {
    width: auto;
    padding: 0.3rem 0;
    img {
      height: 1.5rem;
      max-width: 1.5rem;
    }
    h4 {
      font-size: 0.8rem;
    }

  }


  ${props => props.isFocused ? css`

    height: 120px;
    box-shadow: 0px 2px 5px #0000008c;
    background: #FFF;
    display: flex;
    align-items: flex-start;
    z-index: 999;
  ` :
    css`
    height: 0;
  `};
`;
